import { AppShell } from "@/components/AppShell";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/ui-kit";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MANAGER_ROLES, useBranch, BranchSelect } from "@/components/transport/common";
import { DriverView } from "@/components/transport/DriverView";
import { ParentTransport } from "@/components/transport/ParentTransport";
import { LivePanel } from "@/components/transport/LivePanel";
import { VehiclesPanel } from "@/components/transport/VehiclesPanel";
import { StaffPanel } from "@/components/transport/StaffPanel";
import { RoutesPanel } from "@/components/transport/RoutesPanel";
import { AssignPanel } from "@/components/transport/AssignPanel";
import { ReportsPanel, IncidentsPanel } from "@/components/transport/ReportsPanel";

function SchoolTransport({ manager }) {
  const b = useBranch();
  const tabs = [["live", "Live tracking", <LivePanel branchId={b.branchId} />],
    ...(manager ? [["vehicles", "Vehicles", <VehiclesPanel branchId={b.branchId} />], ["staff", "Drivers & attendants", <StaffPanel branchId={b.branchId} />]] : []),
    ["routes", "Routes", <RoutesPanel branchId={b.branchId} canEdit={manager} />],
    ["students", "Students", <AssignPanel branchId={b.branchId} canEdit={manager} />],
    ["reports", "Reports", <ReportsPanel branchId={b.branchId} />],
    ...(manager ? [["incidents", "Incidents", <IncidentsPanel branchId={b.branchId} />]] : [])];
  return (
    <>
      <div className="mb-4"><BranchSelect b={b} /></div>
      <Tabs defaultValue="live">
        <TabsList className="bg-white flex-wrap h-auto mb-4">{tabs.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`transport-tab-${k}`}>{l}</TabsTrigger>)}</TabsList>
        {tabs.map(([k, , el]) => <TabsContent key={k} value={k}>{b.branchId ? el : null}</TabsContent>)}
      </Tabs>
    </>
  );
}

export default function TransportPage() {
  const { user } = useAuth();
  const role = user?.role;
  const manager = MANAGER_ROLES.includes(role);
  const sub = role === "parent" ? "Your child's bus, route, contacts and live location." : role === "transport_staff" ? "Your vehicle, route and today's trips." : manager ? "Vehicles, drivers, routes, students, live tracking and boarding reports." : "Bus routes, live status and boarding reports for your branch.";
  return (
    <AppShell>
      <div data-testid="transport-page">
        <PageHeader eyebrow="Transport" title={role === "parent" ? "School Bus" : role === "transport_staff" ? "My Trip" : "Transport Management"} subtitle={sub} />
        {role === "parent" ? <ParentTransport /> : role === "transport_staff" ? <DriverView /> : <SchoolTransport manager={manager} />}
      </div>
    </AppShell>
  );
}
